module.exports = __webpack_public_path__ + "pinduActive.10d18d64.png";